/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number } from 'prop-types'

const RedCheck = ({ width = 15, height = 12 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 15 12">
      <title>RedCheck</title>
      <path
        fill="#F55D3C"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
        d="M1.49439865 5.55071809L4.79391249 8.93469425 13.5056014 0 15 1.53265288 4.79391249 12 4.79391249 12 4.79285563 12 0 7.08445488z"
      />
    </svg>
  )
}

RedCheck.propTypes = {
  height: number,
  width: number,
}

export default RedCheck
